import { APIKit } from "config/axios/index";
import store from "config/redux/index";
import { start, end } from "config/redux/slice";

import { ServerConstants, ServiceConstants } from "constant";
import { ServiceModel } from "models";

import { AppUtils } from "utils";

import { handleErrorWithTokenRenewal } from "./common";

const { API_V1_PRELIMINARY_CREDITS } = ServerConstants;
const {
  REQUEST_PRELIMINARY_CREDIT_VIEW_ID,
  REQUEST_PRELIMINARY_CREDIT_NEW_ID,
  REQUEST_PRELIMINARY_CREDIT_OPTIONS_ID,
  REQUEST_PRELIMINARY_CREDIT_UPDATE_MULTIPLE_ID,
  REQUEST_PRELIMINARY_CREDIT_DELETE_ID,
} = ServiceConstants;

export async function preliminaryCreate(userId: number) {
  const requestId = REQUEST_PRELIMINARY_CREDIT_NEW_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.post(API_V1_PRELIMINARY_CREDITS, { userId });
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, preliminaryCreate, [userId], requestId);
  }
}

export async function preliminaryGetByUser(userId: number) {
  const requestId = REQUEST_PRELIMINARY_CREDIT_VIEW_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.get(`${API_V1_PRELIMINARY_CREDITS}/user/${userId}`);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    const status = err?.status ?? err?.response?.status;

    // Missing preliminary credit is a valid state for comparison fallback.
    if (status === 404) {
      store.dispatch(end(new ServiceModel(requestId)));
      return;
    }

    handleErrorWithTokenRenewal(err, preliminaryGetByUser, [userId], requestId);
  }
}

export async function preliminaryGetOptions() {
  const requestId = REQUEST_PRELIMINARY_CREDIT_OPTIONS_ID;
  try {
    store.dispatch(start(requestId));
    const response = await APIKit.get(`${API_V1_PRELIMINARY_CREDITS}/options`);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, preliminaryGetOptions, [], requestId);
  }
}

export async function preliminaryUpdateMultiple(id: number, data: any) {
  const requestId = REQUEST_PRELIMINARY_CREDIT_UPDATE_MULTIPLE_ID;
  try {
    store.dispatch(start(requestId));
    const body = Object.keys(data).map((el) => ({
      name: el,
      value: AppUtils.convertToAppropriateValue(data[el]),
    }));
    const response = await APIKit.patch(`${API_V1_PRELIMINARY_CREDITS}/${id}/multiple`, body);
    store.dispatch(end(new ServiceModel(requestId, response.data)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, preliminaryUpdateMultiple, [id, data], requestId);
  }
}

export async function preliminaryDelete(id: number) {
  const requestId = REQUEST_PRELIMINARY_CREDIT_DELETE_ID;
  try {
    store.dispatch(start(requestId));
    await APIKit.delete(`${API_V1_PRELIMINARY_CREDITS}/${id}`);
    store.dispatch(end(new ServiceModel(requestId, undefined)));
  } catch (err: any) {
    handleErrorWithTokenRenewal(err, preliminaryDelete, [id], requestId);
  }
}
